<template>
  <md-dialog
    class="Respaldo"
    :md-active.sync="showDialogRespaldo"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
  >
    <md-dialog-title align="center">{{
      doingRespaldo ? "Respaldando" : "¿Deseas respaldar tu información?"
    }}</md-dialog-title>
    <md-dialog-content v-if="doingRespaldo">
      <div class="md-layout md-alignment-center">
        <md-progress-spinner
          style="align:center"
          class="md-accent"
          md-mode="indeterminate"
        />
        <br />
        <div class="md-layout-item md-size-100">
          <div class="md-layout md-alignment-center">
            <p
              align="center"
              style="max-width:300px"
            >
              Espere un momento.<br />Al terminer el respaldo se descargará una
              copia en su dispositivo.
            </p>
          </div>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions v-if="!doingRespaldo">
      <md-button @click="showDialogRespaldo = false">No, continuar</md-button>
      <md-button
        class="md-raised md-primary"
        @click="_hacerRespaldo"
      >Si, respaldar</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import exportFromJSON from "export-from-json";
export default {
  name: "Respaldo",
  methods: {
    _hacerRespaldo() {
      this.doingRespaldo = true;
      const fileName = "respaldo" + Date.now();
      const exportType = "txt";
      const data = {
        escuelas: JSON.parse(localStorage.getItem("escuelas")),
        escuelas_contactos: JSON.parse(
          localStorage.getItem("escuelas_contactos")
        ),
        escuelas_citas: JSON.parse(localStorage.getItem("escuelas_citas")),
        pacientes: JSON.parse(localStorage.getItem("pacientes"))
      };

      exportFromJSON({
        data,
        fileName,
        exportType
      });
      this.doingRespaldo = false;
    }
  },
  data() {
    return {
      showDialogRespaldo: false,
      doingRespaldo: false
    };
  }
};
</script>
